import { render, staticRenderFns } from "./FhGanaderiaNavDrawer.vue?vue&type=template&id=fa0dae98&"
import script from "./FhGanaderiaNavDrawer.vue?vue&type=script&lang=js&"
export * from "./FhGanaderiaNavDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports